import { ChallengeInteractivity, ChallengeStatus } from '@/model';
import { DateFilterInputValue } from '@/components/DateRangeFilterFields/types';
import { t } from '@/i18n';

export enum ChallengeInteractivityFilter {
  NOT_STARTED = 'NOT_STARTED',
}

export const translateChallengeInteractivityFilter = (status: ChallengeInteractivityFilter): string => {
  switch (status) {
    case ChallengeInteractivityFilter.NOT_STARTED:
      return t('pages.application_challenge.application_challenge_app_area_not');
    default:
      return status;
  }
};

export interface ChallengeFilters {
  team_uuid?: string;
  title?: string;
  status?: ChallengeStatus | undefined;
  interactivity?: ChallengeInteractivity | ChallengeInteractivityFilter | undefined;
  dateValue?: DateFilterInputValue;
  start_date?: string;
  end_date?: string;
}
